import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material"
import type { FC } from "react"
import React from "react"
import { Controller, useFormContext } from "react-hook-form"

import { FormNumericField } from "@/components/UiKit"
import { CURRENCY_RENDER_PRECISION } from "@/constants/formats"
import { FIELD_LABEL_CLASSES } from "@/constants/forms"
import NumericTypeField from "@/screens/Pricing/components/forms/NumericTypeField"

const AcceptedCostField: FC = () => {
  const { control } = useFormContext()

  return (
    <Box>
      <label htmlFor='acceptedCost' className={FIELD_LABEL_CLASSES}>
        Desired Accepted Cost
      </label>

      <Box className='flex items-center gap-1'>
        <Box className='min-w-[90px]'>
          <FormNumericField
            control={control}
            name='acceptedCost'
            decimalScale={CURRENCY_RENDER_PRECISION}
            data-testid='price-change.bulk-update-form.accepted-cost-field'
          />
        </Box>

        <NumericTypeField name='acceptedCostType' />

        <Controller
          name='maintainMargin'
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox size='small' checked={!!field.value} onChange={(e) => field.onChange(e.target.checked)} />
              }
              label={<Typography className='whitespace-nowrap text-sm font-normal'>Maintain margins</Typography>}
            />
          )}
        />
      </Box>
    </Box>
  )
}

export default AcceptedCostField
